import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_CONTENT_SNIPPET = gql`
  mutation createContentSnippet(
    $containerId: Int!
    $visible: Boolean!
    $contentSnippetId: Int!
  ) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible }
        contentSnippetImageMap: { contentGroupId: $contentSnippetId }
      ) {
        id
        sort
      }
    }
  }
`;

const createImageMapContentSnippetRequest = ({
  containerId,
  isVisible,
  contentSnippetId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        contentSnippetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.contentSnippet.createContentSnippet.id,
          data.contentSnippet.createContentSnippet.sort
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createImageMapContentSnippetRequest.propTypes = {
  containerId: PropTypes.number.isRequired,
  contentSnippetId: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

createImageMapContentSnippetRequest.defaultProps = {};

export default createImageMapContentSnippetRequest;
